import { Button, Grid } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Member } from 'src/modules/member/models/member';
import { DateHelper } from 'src/shared/helpers/dateHelper';
import { ContentSection } from 'src/shared/components/organisms/contentSection';
import { ContentLabelAndValue } from 'src/shared/components/organisms/contentLabelAndValue';
import { StickyNote2 } from '@mui/icons-material';
import { getPermission } from 'src/shared/functions/getSysProductPermissions';
import { PermissionEnum } from 'src/shared/models/enums/permissionEnums';
import { useGlobals } from 'src/shared/contexts/appContext';
import { MemberRecentChangeInfoModal } from './memberRecentChangeInfoModal';

type MemberRecentChangeInfoProps = {
  member: Member;
};

export const MemberRecentChangeInfo = (props: MemberRecentChangeInfoProps) => {
  const { member } = props;
  const { t } = useTranslation();
  const [openChangeLogs, setOpenChangeLogs] = useState<boolean>(false);
  const { currentUser } = useGlobals();

  const hasMemberUpdatePermission = getPermission(currentUser, PermissionEnum.MemberUpdate);

  return (
    <>
      {member && member.member_id && (
        <Grid item xs={12}>
          <ContentSection
            header={t('member:tableHeaders.changedDate')}
            button={
              <Button
                disabled={!hasMemberUpdatePermission}
                type='button'
                variant='outlined'
                size='small'
                endIcon={<StickyNote2 fontSize='small' />}
                onClick={() => setOpenChangeLogs(true)}
              >
                {t('member:tableHeaders.changeHistory')}
              </Button>
            }
          >
            <ContentLabelAndValue label={t('member:tableHeaders.date')} value={DateHelper.getDateTime(member?.changedDate)} />
            <ContentLabelAndValue label={t('member:tableHeaders.changedBy')} value={member?.changedBy} />
          </ContentSection>
          <MemberRecentChangeInfoModal
            modalOpen={openChangeLogs}
            onClose={() => setOpenChangeLogs(false)}
            memberId={member.member_id}
            firstName={member.firstName}
            lastName={member.lastName}
          />
        </Grid>
      )}
    </>
  );
};
